import { FormEvent, useState } from 'react'

import RichText from '../../00-Primitives/Inputs/RichText'
import CommentDetails from '../Comment/Details'
import FormButtons from '../FormButtons'

type Props = {
  className?: string
  onSubmit: (text: string) => Promise<void>
  buttonText: string
  onClose: () => void
  closeFormLabelText: string
  placeholderText?: string
  userName: string
}

function CommentForm({
  className,
  onSubmit,
  buttonText,
  onClose,
  closeFormLabelText,
  userName,
  placeholderText = '',
}: Props) {
  const [text, setText] = useState('')

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    onSubmit(text)
  }

  return (
    <form className={className} onSubmit={handleSubmit}>
      <CommentDetails authorName={userName} createdAt={new Date()} />
      <RichText
        label={placeholderText}
        placeholder={placeholderText}
        updateField={setText}
        value={text}
      />
      <FormButtons
        submitButtonText={buttonText}
        closeButtonLabelText={closeFormLabelText}
        onClose={onClose}
      />
    </form>
  )
}

export default CommentForm
